import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1>Om Sykkelfest</h1>

        <div className="about-content">
          <section className="story-section">
            <h2>Hvordan startet det?</h2>
            <p>
              Det hele begynte en sen ettermiddag 2. juledag 2025. Familien var samlet, sjakk-VM 
              spilte på TV-en, og stemningen var avslappet og hyggelig. Under en samtale med 
              familiemedlemmer som bor i Sverige, kom konseptet "Sykkelfest" opp i samtalen.
            </p>
            <p>
              For Simon Skotheimsvik satte dette umiddelbart i gang noe. Med sin "systemerings"-bakgrunn 
              så han med en gang mulighetene – og utfordringen fenget ham. Rett og slett kunne 
              han ikke la ideen gå. Faktisk var han så inspirert at han kjøpte domenet 
              <strong> sykkelfest.no</strong> der og da, i familieselskapet hvor hurtigsjakkpartiet fortsatt rullet på TV.
            </p>
            <p>
              Det som startet som en idé under romjulen, utviklet seg raskt til et større prosjekt. 
              Utviklingen og testingen startet umiddelbart, og det viste seg å være et langt dypere 
              kaninhull enn først antatt. Resultatet er plattformen du ser i dag – et komplett system 
              for å tilrettelegge for sosiale sykkelfester.
            </p>
          </section>

          <section className="creator-section">
            <h2>Hvem står bak?</h2>
            <div className="creator-content">
              <div className="creator-image">
                <img 
                  src="/simon-portrait.png" 
                  alt="Simon Skotheimsvik" 
                />
              </div>
              <div className="creator-info">
                <h3>Simon Skotheimsvik</h3>
                <p>
                  Simon er en IT-konsulent med lang erfaring innen ny teknologi, systemdrift og 
                  prosjektledelse. Ved siden av IT-karrieren er han også hobbymusiker som har spilt land og strand
                  på konserter, puber og dansetilstelninger.
                </p>
                <p>
                  Kombinasjonen av teknisk ekspertise og kreativt engasjement gjør ham godt rustet 
                  til å skape innovative løsninger som Sykkelfest – en plattform som bringer 
                  mennesker sammen på en spennende måte.
                </p>
                <div className="contact-links">
                  <a 
                    href="https://linktr.ee/simonskotheimsvik" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    Kontakt & Lenker
                  </a>
                </div>
              </div>
            </div>
          </section>

          <section className="vision-section">
            <h2>Visjonen</h2>
            <p>
              Sykkelfest handler om mer enn bare sykling – det handler mest om å skape sosiale 
              møteplasser, og gi folk mulighet til å møte nye 
              mennesker i sitt lokalområde på en morsom og uforpliktende måte.
            </p>
            <p>
              Gjennom å kombinere sykling, mat og nye bekjentskaper, ønsker vi å skape 
              minnerike opplevelser som bygger fellesskap og fremmer både fysisk aktivitet 
              og sosial samhandling.
            </p>
          </section>

          <section className="tech-section">
            <h2>Teknologi</h2>
            <p>
              Sykkelfest-plattformen er bygget med moderne webteknologi og kjører 100% i 
              Microsoft Azure-skyen. Systemet håndterer alt fra brukerregistrering og 
              arrangementplanlegging til automatisk rutegenerering og e-postvarsling.
            </p>
            <p>
              Plattformen er utviklet med fokus på brukervennlighet, automatisering og 
              skalerbarhet – slik at arrangører kan fokusere på det viktigste: å skape 
              gode opplevelser for deltakerne.
            </p>
          </section>

          <section className="cta-section">
            <h2>Vil du bli med?</h2>
            <p>
              Enten du vil delta i et arrangement eller organisere ditt eget, er du velkommen! 
              Sykkelfest er for alle som liker sykling, mat og nye bekjentskaper.
            </p>
            <div className="cta-buttons">
              <a href="/opprett-konto" className="btn btn-primary btn-large">
                Bli deltaker
              </a>
              <a href="/deltaker/bli-arrangor" className="btn btn-primary btn-large">
                Bli arrangør
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
